import { createBrowserRouter, redirect } from "react-router-dom";
import App from "./App";
import LoginPage from "./core/auth/pages/login/LoginPage";
import OrdersPage from "./features/orders/pages/orders.page";
import EmployeesPage from "./features/employees/employees.page";
import LandingPage from "./core/pages/landing-page/landing.page";
import TermsAndConditionsPage from "./core/pages/terms-and-conditions/terms-and-conditions.page";
import DashboardPage from "./features/dashboard/dashboard.page";
import CarServicesPage from "./features/car-services/pages/car-services.page";
import UsersPage from "./features/users";
import CustomersPage from "./features/customers";
import AddOrder from "./features/orders/components/create-order";
import AddCarService from "./features/car-services/pages/add-car-service.page";
import AddEmployee from "./features/employees/components/add-employee";
import LandingLayout from "./shared/components/layout/LandingLayout";
import RegisterPage from "./core/auth/pages/register/Register";
import QueuePage from "./features/queue/queue-page";
import { SettingsPage } from "./features/settings";
import CategoryPage from "./features/categories/categories-page";
import AddCategory from "./features/categories/components/add-category";
import SubCategoriesPage from "./features/sub-categories/sub-categories-page";
import AddSubCategory from "./features/sub-categories/components/add-sub-category";
import POSPage from "./features/pos/pages/pos.page";
import OrderDetailsPage from "./features/orders/pages/orders-details.page";
import EmployeeDetails from "./features/employees/components/employee-details-page";
import ResetPassword from "./core/auth/pages/reset-password/reset-password";
import ResetPasswordToken from "./core/auth/pages/reset-password-token/reset-password-token";
import NotFound from "./core/pages/not-found/not-found.page";
import PrinterComponent from "./features/printer/printer.component";
import Transactions from "./features/transactions/transactions.page";
import SupportPage from "./features/support/pages/support.page";
import CompaniesPage from "./features/companies/pages/companies.page";
import DesignSystemPage from "./features/design-system/design-system.page";

const routes = createBrowserRouter([
  {
    path: "/",
    element: <LandingLayout />,
    children: [
      {
        path: "/",
        element: <LandingPage />,
      },
      {
        path: "/terms-conditions",
        element: <TermsAndConditionsPage />,
      },
      {
        path: "sign-in",
        element: <LoginPage />,
      },
      {
        path: "sign-up",
        element: <RegisterPage />,
      },
      {
        path: "reset-password/:email",
        element: <ResetPassword />,
      },
      {
        path: "reset-password-token",
        element: <ResetPasswordToken />,
      },
    ],
  },
  {
    path: "/app",
    element: <App />,
    id: "Home",
    children: [
      {
        index: true,
        loader: () => redirect("dashboard"),
      },
      {
        path: "dashboard",
        element: <DashboardPage />,
        handle: {
          crumb: () => ({ link: "/app/dashboard", name: "Dashboard" }),
        },
      },
      // {
      //   path: "queue",
      //   element: <QueuePage />,
      //   handle: {
      //     crumb: () => ({ link: "/app/queue", name: "Queue" }),
      //   },
      // },
      // {
      //   path: "queue",
      //   element: <PrinterComponent order={undefined} />,
      //   handle: {
      //     crumb: () => ({ link: "/app/queue", name: "Queue" }),
      //   },
      // },
      {
        path: "orders",
        element: <OrdersPage />,
        handle: {
          crumb: () => ({ link: "/app/orders", name: "Orders" }),
        },
      },
      {
        path: "orders/:id",
        element: <OrderDetailsPage />,
        handle: {
          crumb: (match) => {
            console.log('match',match);
            
            return {
              link: `app/orders/${match?.params?.id}`,
              name: "Order Details",
            };
          },
        },
      },
      {
        path: "pos",
        element: <POSPage />,
        handle: {
          crumb: () => ({ link: "/app/pos", name: "POS" }),
        },
      },
      {
        path: "car-services",
        element: <CarServicesPage />,
        handle: {
          crumb: () => ({ link: "/app/car-services", name: "Car Services" }),
        },
      },
      {
        path: "employees",
        element: <EmployeesPage />,
        handle: {
          crumb: () => ({ link: "/app/employees", name: "Employees" }),
        },
      },
      // transactions 
      {
        path: "transactions",
        element: <Transactions />,
        handle: {
          crumb: () => ({ link: "/app/transactions", name: "Transactions" }),
        },
      },
      {
        path: "employees/:id",
        element: <EmployeeDetails />,
        handle: {
          crumb: (match) => {
            console.log('match',match);
            
            return {
              link: `app/employees/${match?.params?.id}`,
              name: "Employee Details",
            };
          },
        },
        
      },
      // users
      {
        path: "users",
        element: <UsersPage />,
        handle: {
          crumb: () => ({ link: "/app/users", name: "Users" }),
        },
      },
      // companies
      {
        path: "companies",
        element: <CompaniesPage />,
        handle: {
          crumb: () => ({ link: "/app/companies", name: "Companies" }),
        },
      },
      // categories
      {
        path: "categories",
        element: <CategoryPage />,
        handle: {
          crumb: () => ({ link: "/app/categories", name: "Categories" }),
        },
      },
      {
        path: "sub-categories",
        element: <SubCategoriesPage />,
        handle: {
          crumb: () => ({ link: "/app/sub-categories", name: "Sub Categories" }),
        },
      },
      // settings
      {
        path: "settings",
        element: <SettingsPage />,
        handle: {
          crumb: () => ({ link: "/app/settings", name: "Settings" }),
        },
      },
      {
        path: "customers",
        element: <CustomersPage />,
        handle: {
          crumb: () => ({ link: "/app/customers", name: "Customers" }),
        },
      },
      // add order page
      {
        path: "add-order",
        element: <AddOrder />,
        handle: {
          crumb: () => ({ link: "/app/add-order", name: "Add Order" }),
        },
      },
      {
        path: "add-carservice",
        element: <AddCarService />,
        handle: {
          crumb: () => ({ link: "/app/add-carservice", name: "Add Car Service" }),
        },
      },
      {
        path: "add-employee",
        element: <AddEmployee />,
        handle: {
          crumb: () => ({ link: "/app/add-employee", name: "Add Employee" }),
        },
      },
      {
        path: "add-category",
        element: <AddCategory />,
        handle: {
          crumb: () => ({ link: "/app/add-category", name: "Add Category" }),
        },
      },
      {
        path: "add-sub-category",
        element: <AddSubCategory />,
        handle: {
          crumb: () => ({ link: "/app/add-sub-categor", name: "Add Sub Category" }),
        },
      },

      // {
      //   path: 'admin',
      //   element: <Admin />,
      //   children: [
      //     {
      //       path: '',
      //       element: <Dashboard/>,
      //     },
      //     {
      //       path: 'users',
      //       element: <UsersPage />,
      //     },
      //     {
      //       path: 'subscriptions',
      //       element: <SubscriptionsPage/>,
      //     },
      //     {
      //       path: 'pricing-plans',
      //       element: <PricingPlansPage/>,
      //     },
      //   ],
      // },
      {
        path: "support",
        element: <SupportPage />,
        handle: {
          crumb: () => ({ link: "/app/support", name: "Support" }),
        },
      },
      {
        path: "support/:id",
        element: <OrderDetailsPage />,
        handle: {
          crumb: (match) => {
            console.log('match',match);
            
            return {
              link: `app/support/${match?.params?.id}`,
              name: "Support Details",
            };
          },
        },
      },
    ],
  },
  {
    path: "/design",
    element: <DesignSystemPage />,
  },
  {
    path: "*", // Catch-all route for unmatched paths
    element: <NotFound />,
  },
]);

// function AppRouter() {
//   // props: Props
//   // const {} = props;

//   return (
//     <Router>
//       <Routes>
//         <Route path="/register" element={<CarServicesList />} />
//         <Route path="/login" element={<LoginPage />} />
//         {/* <Route path="/dashboard" element={<>Users Edit</>} /> */}
//         {/* <Route element={<Layout
//          />}> */}
//         <Route path="/car-services" element={<CarServicesList />} />
//         <Route path="/orders" element={<Orders />} />
//         <Route path="/users" element={<Employees />} />
//         <Route path="/users/add" element={<>Users Add</>} />
//         <Route path="/dashboard" element={<Dashboard />} />
//         <Route path="/users/edit" element={<>Users Edit</>} />
//         <Route path="/users" element={<>Users List @</>} />
//         <Route path="/users/add" element={<>Users Add</>} />
//         <Route path="/users/edit" element={<>Users Edit</>} />
//         {/* </Route> */}
//       </Routes>
//     </Router>
//   );
// }

export default routes;
